import { StyleSheet, View } from "react-native";
import { useTranslation } from "react-i18next";
import CustomText from "../components/common/general/CustomText/CustomText";

type LTIErrorStateProps = {
  title?: string;
  message: string;
  recoveryTitle?: string;
  recoveryMessage: string;
};

const DEFAULT_TITLE_KEY = "Unable to load this LTI page";
const DEFAULT_RECOVERY_TITLE_KEY = "What you can do";

function LTIErrorState({ title, message, recoveryTitle, recoveryMessage }: LTIErrorStateProps) {
  const { t } = useTranslation();

  const resolvedTitle = title ?? t(DEFAULT_TITLE_KEY);
  const resolvedRecoveryTitle = recoveryTitle ?? t(DEFAULT_RECOVERY_TITLE_KEY);

  return (
    <View style={styles.container}>
      <CustomText
        text={resolvedTitle}
        size="xl"
        weight="bold"
        role="heading"
        aria-level={1}
        useTranslationText={false}
        style={styles.title}
      />
      <CustomText text={message} size="m" useTranslationText={false} style={styles.description} />
      <CustomText
        text={resolvedRecoveryTitle}
        size="l"
        weight="bold"
        role="heading"
        aria-level={2}
        useTranslationText={false}
        style={styles.recoveryTitle}
      />
      <CustomText text={recoveryMessage} size="m" useTranslationText={false} style={styles.recoveryDescription} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    minHeight: 0,
    minWidth: 0,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
    backgroundColor: "#ffffff",
  },
  title: {
    textAlign: "center",
    maxWidth: 680,
  },
  description: {
    marginTop: 12,
    textAlign: "center",
    color: "#475467",
    maxWidth: 680,
  },
  recoveryTitle: {
    marginTop: 24,
    textAlign: "center",
  },
  recoveryDescription: {
    marginTop: 8,
    textAlign: "center",
    color: "#475467",
    maxWidth: 680,
  },
});

export default LTIErrorState;
